import React from 'react'

const NotificationsMenu: React.FC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      y="0.5"
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_103_17175)"
      fillOpacity="0.1"
    />
    <g clipPath="url(#clip0_103_17175)">
      <path
        d="M22.3864 19.1474C22.3288 19.0786 22.2722 19.0097 22.2167 18.9433C21.4535 18.0273 20.9917 17.4744 20.9917 14.8814C20.9917 13.5389 20.668 12.4373 20.03 11.6112C19.5596 11.0008 18.9237 10.5378 18.0855 10.1957C18.0747 10.1897 18.0651 10.1819 18.057 10.1726C17.7556 9.17091 16.9306 8.5 16.0001 8.5C15.0696 8.5 14.245 9.17091 13.9435 10.1716C13.9355 10.1805 13.926 10.1881 13.9154 10.194C11.9594 10.9929 11.0088 12.5258 11.0088 14.8803C11.0088 17.4744 10.5478 18.0273 9.78381 18.9422C9.7283 19.0087 9.67175 19.0762 9.61416 19.1464C9.4654 19.3244 9.37115 19.541 9.34256 19.7705C9.31397 20 9.35224 20.2328 9.45284 20.4414C9.6669 20.8889 10.1231 21.1667 10.6439 21.1667H21.3602C21.8785 21.1667 22.3316 20.8892 22.5463 20.4438C22.6473 20.2351 22.686 20.0021 22.6576 19.7724C22.6293 19.5426 22.5351 19.3257 22.3864 19.1474Z"
        fill="#052351"
      />
      <path
        d="M15.9998 24.5C16.5433 24.4995 17.0766 24.3361 17.543 24.027C18.0095 23.718 18.3917 23.2748 18.6492 22.7446C18.6614 22.7192 18.6673 22.6907 18.6666 22.662C18.6659 22.6333 18.6585 22.6052 18.6451 22.5806C18.6317 22.556 18.6127 22.5356 18.5901 22.5215C18.5675 22.5074 18.542 22.5 18.5161 22.5H13.4843C13.4583 22.4999 13.4328 22.5073 13.4101 22.5213C13.3875 22.5354 13.3685 22.5558 13.3551 22.5804C13.3416 22.605 13.3342 22.6331 13.3334 22.6619C13.3327 22.6906 13.3387 22.7191 13.3508 22.7446C13.6083 23.2748 13.9904 23.7179 14.4568 24.0269C14.9232 24.336 15.4564 24.4994 15.9998 24.5Z"
        fill="#052351"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_103_17175"
        x1="15.7922"
        y1="0.5"
        x2="15.7922"
        y2="32.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0062FF" />
        <stop offset="1" stopColor="#004BC2" />
      </linearGradient>
      <clipPath id="clip0_103_17175">
        <rect width="16" height="16" fill="white" transform="translate(8 8.5)" />
      </clipPath>
    </defs>
  </svg>
)

export default NotificationsMenu
